export default __webpack_public_path__ + "static/tab4Img-6f26de2c6bb1525a84f965933df4e565.png";